// extracted by mini-css-extract-plugin
module.exports = {"container":"Landing_container__39GR7","stage":"Landing_stage__1hNAF","buttonLink":"Landing_buttonLink__2etfC","button":"Landing_button__3D_A4","press":"Landing_press__1xX3h"};